module.exports = __webpack_public_path__ + "static/rat-bf2a1a8411fb70d58f571cb3aa149ed9.jpg";